import { C } from './complex';

/**
 * Quantum Fourier Transform on an n-qubit state vector, applied directly as
 * the N-point unitary DFT it mathematically is:
 * output[k] = (1/sqrt(N)) * sum_j input[j] * e^{2*pi*i*j*k/N}
 * (equivalent to — not decomposed into — the usual H + controlled-phase
 * gate circuit; the transform itself is identical either way).
 */
export const qft = (state) => {
  const N = state.length;
  const norm = 1 / Math.sqrt(N);
  const output = [];
  for (let k = 0; k < N; k++) {
    let sumRe = 0, sumIm = 0;
    for (let j = 0; j < N; j++) {
      const angle = (2 * Math.PI * j * k) / N;
      const c = Math.cos(angle), s = Math.sin(angle);
      sumRe += state[j].re * c - state[j].im * s;
      sumIm += state[j].re * s + state[j].im * c;
    }
    output.push(C(sumRe * norm, sumIm * norm));
  }
  return output;
};
